import fly from 'flyio'
import md5 from 'md5'
import { Message, MessageBox } from 'element-ui'
import { getToken } from '../utils'
// import { UserModule } from '@/store/modules/user'

// request拦截器
fly.interceptors.request.use(config => {
  const { body = {} } = config
  if (getToken) {
    config.headers['access-token'] = getToken()
  }
  body.timestamp = Date.now()
  let paraStr = ''
  for (const value of Object.keys(body).sort()) {
    if (body[value] !== undefined && body[value] !== null) {
      paraStr += body[value].toString()
    }
  }
  body.auth_key = process.env.VUE_APP_AUTH_KEY
  body.token = md5(paraStr + process.env.VUE_APP_AUTH_SECRET)
  config.body = body
  return config
})

// respone拦截器
fly.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000,
      })

      // // 403:token过期; 514: token验证失败
      // if (res.code === 403 || res.code === 514) {
      //   UserModule.FedLogOut().then(() => {
      //     location.reload() // 为了重新实例化vue-router对象 避免bug
      //   })
      // }
      return Promise.reject({ msg: res.msg })
    } else {
      return response
    }
  },
  (error) => {
    console.log('err' + error) // for debug
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  }
)
fly.config.baseURL = process.env.BASE_API

export default fly



// WEBPACK FOOTER //
// ./src/utils/request.js